import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Application } from './Application.js';

/**
 * LA POLICE EMBARQUÉE EST RETIRÉE — 04/09/2026, en fin de journée.
 *
 * L'import de `@fontsource-variable/inter/wght.css` a été posé ici quelques
 * heures plus tôt, puis retiré le jour même. **La faute est de conception, pas
 * de code** : ajouter une dépendance oblige à un `pnpm install` sur le poste de
 * l'utilisateur, et cette installation ne peut pas être lancée à sa place —
 * l'environnement qui accède à son dossier est Linux, ses paquets sont
 * `win32-x64`, et une installation depuis là remplacerait ses binaires.
 *
 * Résultat constaté : `GET /src/main.tsx` répondait **500, « Failed to resolve
 * import »**, et `localhost:5173` rendait une page blanche. L'utilisateur s'est
 * retrouvé sans logiciel, loin de son poste, pour une question d'apparence.
 *
 * **CE QU'IL FALLAIT FAIRE, ET QU'ON FERA QUAND ON REPRENDRA LE SUJET** :
 * vérifier qu'un changement peut être livré SANS commande à taper chez lui,
 * avant de le pousser. Une police se sert aussi depuis `apps/web/public/`, avec
 * un `@font-face` dans `styles.css` : aucun paquet, donc aucune installation.
 *
 * La dépendance reste déclarée dans `apps/web/package.json` et dans le
 * `pnpm-lock.yaml` — les retirer demanderait un `pnpm install` de plus, c'est-
 * à-dire exactement le problème qu'on répare. Elle ne coûte rien tant que
 * personne ne l'importe, et elle sera là le jour où on remettra Inter.
 *
 * CE QUI RESTE VRAI ET QU'IL NE FAUT PAS OUBLIER : `styles.css` demande des
 * polices que RIEN NE CHARGE. Sur un poste Windows, l'écran s'affiche en Segoe
 * UI et Consolas — d'où les zéros barrés — et il n'a donc pas le même aspect
 * d'un poste à l'autre. Le défaut est réel ; c'est le remède qui était mauvais.
 */

import './styles.css';

const racine = document.getElementById('racine');
if (!racine) {
  throw new Error('Élément #racine introuvable dans index.html');
}

createRoot(racine).render(
  <StrictMode>
    <Application />
  </StrictMode>,
);
